import { RoleActionTypes } from './actionTypes';

type InitialState = {
  selectedRole: MedScout.Role | null;
  editOrCopyRole: MedScout.Role | null;
};

export const initialRolesState: InitialState = {
  selectedRole: null,
  editOrCopyRole: null,
};

export const rolesReducer = (state = initialRolesState, action: any) => {
  switch (action.type) {
    case RoleActionTypes.SET_SELECTED_ROLE:
      return {
        ...state,
        selectedRole: action.payload,
      };
    case RoleActionTypes.SET_EDIT_OR_COPY_ROLE:
      return {
        ...state,
        editOrCopyRole: action.payload,
      };
    default:
      return state;
  }
};
